<template>
  <Header :siteTitle="this.siteTitle" :siteDesc="this.siteDesc" />
  <Main :lessons="this.lessons" :siteMenu="this.siteMenu" />
</template>

<script>

import Header from './components/Header.vue';
import Main from './components/Main.vue';

export default {
  name: "App",
  components: {
    Header,
    Main
  },

  data(){
    return {
      siteTitle: "Embed a Lesson",
      siteDesc: "The Learn2Learn module is self-paced module designed to help and support students in the development and enhancement of their self-regulated-learning skills. This site will allow you to choose a lesson from the module and embed it in-line with your instructional materials within your vUWS site.",
      siteMenu: undefined,
      lessons: undefined
    }
  },

  created() {
    this.axios
      .get('https://lf.westernsydney.edu.au/p/learn2learn/wp-json/learn2learn/v1/getlessons')
      .then((response) => {
          const responseData = response.data;
          if (responseData["menu-items"] !== "undefined"){
            this.siteMenu = responseData["menu-items"];
            delete responseData["menu-items"];
          }
          this.lessons = responseData;
      });
  }

};
</script>
